import React, { useEffect } from 'react';
import './MessageComponent.scss';
import MessageIcon from '../../Assets/images/HomePage/messageIcon.svg';
import Button from '../Button/Button';

type initialProps = {
    backToHomeHandler: any;
};

const MessageComponent = (props: initialProps) => {
    const { backToHomeHandler } = props;
    useEffect(() => {
        window.scroll(0, 0);
    }, []);
    let customerDetail: any = localStorage.getItem('customerDetail');
    customerDetail = JSON.parse(customerDetail);
    return (
        <>
            <div className="messageComponent">
                <div className="image">
                    <img src={MessageIcon} alt="message icon" />
                </div>
                <div className="heading">Order Placement Underway</div>
                <div className="desc">
                    Order processing is taking longer than usual. Please check the order status later. If the issue
                    persists, call us at 1.800.427.8686 for assistance.
                </div>
                <div className="backToHome">
                    <Button primary={true} onClick={backToHomeHandler}>
                        Home
                    </Button>
                </div>
            </div>
        </>
    );
};

export default MessageComponent;
